module.exports = __webpack_public_path__ + "8ad09aa8f08d825a52301d12cdd1827e.svg";